import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "@phosphor-icons/react";
import { reveal, container } from "../lib/motion";
import { PORTFOLIO } from "../data/site";

const Tile = ({ p }) => (
  <motion.div variants={reveal} className={`group relative overflow-hidden bg-mist ${p.span}`} data-testid={`portfolio-${p.tag.toLowerCase().replace(/[^a-z]/g, "-")}`}>
    <div className={`relative w-full overflow-hidden ${p.h}`}>
      <img
        src={`${p.img}?auto=format&fit=crop&w=1200&q=80`} alt={p.tag} loading="lazy"
        className="h-full w-full object-cover grayscale transition-all duration-700 ease-out group-hover:scale-105 group-hover:grayscale-0"
      />
      <div className="absolute inset-0 bg-ink/0 transition-colors duration-500 group-hover:bg-ink/10" />
    </div>
    <div className="absolute bottom-0 left-0 flex items-center gap-3 p-6">
      <span className="bg-white px-3 py-2 text-xs font-bold uppercase tracking-wider text-ink transition-colors duration-300 group-hover:bg-teal group-hover:text-white">
        {p.tag}
      </span>
    </div>
    <div className="absolute right-6 top-6 flex h-11 w-11 translate-y-2 items-center justify-center bg-white text-ink opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
      <ArrowUpRight size={20} weight="bold" />
    </div>
  </motion.div>
);

export const Portfolio = () => (
  <section id="portfolio" className="bg-mist py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} className="mb-14 flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div className="max-w-2xl">
          <motion.span variants={reveal} className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-teal">
            <span className="h-px w-10 bg-teal" /> Portfolio
          </motion.span>
          <motion.h2 variants={reveal} className="font-display text-4xl font-black leading-[0.95] tracking-tight text-ink md:text-6xl" data-testid="portfolio-headline">
            Creative Work That Supports Stronger Brands
          </motion.h2>
        </div>
        <motion.p variants={reveal} className="max-w-xs font-sans text-sm text-zinc-500">
          A preview of the kind of work we create. Sample placeholders — your project could be next.
        </motion.p>
      </motion.div>

      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-40px" }} className="grid auto-rows-auto gap-4 md:grid-cols-12">
        {PORTFOLIO.map((p) => <Tile key={p.tag} p={p} />)}
      </motion.div>
    </div>
  </section>
);
